import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import lt from './locales/lt.json'

export const SUPPORTED_LANGUAGES = ['en', 'lt'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            lt: { translation: lt },
        },
        fallbackLng: 'en',
        supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'lng',
        },
    })

export default i18n
